export const CONTAINS_URL_REGEX = /[-a-zA-Z0-9@:%_\+.~#?&//=()]{2,256}\.[a-z]{2,4}\b(?:\/[-a-zA-Z0-9@:%_\+.~#?&//=()]*)?/gi;

export const URL_REGEX = /https:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

export const INVALID_URL_CHARACTERS_REGEX = /[^a-zA-Z0-9-_]/g;

export const EMAIL_REGEX = /^\S+@\S+\.\S+$/;

export function isUrl(value: string | null | number) {
    const isMatch = URL_REGEX.test(value?.toString() ?? "");
    return isMatch;
}

export function isEmail(value: string | null | number) {
    return EMAIL_REGEX.test(value?.toString() ?? "");
}

export function isFalsyOrWhitespace(value: string | null | undefined): boolean {
    return !value?.trim();
}

export function isDateInvalid(date: Date): boolean {
    return isNaN(date?.getTime());
}

export function isIsoDate(dateString: string): boolean {
    const date: Date = new Date(dateString);
    return !isDateInvalid(date) && new Date(dateString).toISOString() === dateString;
}

export function isGreaterThanXDaysAfter(date1: Date, date2: Date, days: number): boolean {
    const date1Copy = new Date(date1);
    date1Copy.setHours(0, 0, 0, 0); // Reset time to midnight (ignores time of day)
  
    const date2Copy = new Date(date2);
    date2Copy.setHours(0, 0, 0, 0); // Reset time to midnight (ignores time of day)
  
    const hoursInDay = 24;
    const secondsInMinute = 60;
    const minutesInHour = 60;
    const millisecondsInSecond = 1000;
    return (date2Copy.getTime() - date1Copy.getTime()) > days * hoursInDay * minutesInHour * secondsInMinute * millisecondsInSecond;
  };


export type ValidationResult = {
    message: string,
    isValid: boolean
}